import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, httpDelete, responseIsSuccess } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { bgCompanyReportPath } from 'routes'

const createKeys = (key) => makeKeys(`BG_COMPANY_${key}`)

const GET_LIST = createKeys('GET_LIST')
const GET_DETAIL = createKeys('GET_DETAIL')
const UPDATE = createKeys('UPDATE')
const ACTION_UPDATE = createKeys('ACTION_UPDATE')
const ACTION_RETURN = createKeys('ACTION_RETURN')
const VALIDATE_RETURN = createKeys('VALIDATE_RETURN')
const GET_DETAIL_DOC_FOR_EXTEND = createKeys('GET_DETAIL_DOC_FOR_EXTEND')
const GET_LIST_DOC_FOR_EXTEND = createKeys('GET_LIST_DOC_FOR_EXTEND')
const EXPORT = createKeys('EXPORT')

export const getBGCompany = makeAction(GET_LIST.REQUEST, 'query')
export const getBGCompanyDetail = makeAction(GET_DETAIL.REQUEST, 'id')
export const updateBGCompany = makeAction(UPDATE.REQUEST, 'data', 'isSubmit', 'history', 'confirm','onRequestConfirm')
export const actionUpdateBGCompany = makeAction(ACTION_UPDATE.REQUEST, 'data', 'history')
export const actionReturnBGCompany = makeAction(ACTION_RETURN.REQUEST, 'data', 'history')
export const validateReturn = makeAction(VALIDATE_RETURN.REQUEST, 'id')
export const getDetailDocForExtend = makeAction(GET_DETAIL_DOC_FOR_EXTEND.REQUEST, 'id')
export const getListDocForExtend = makeAction(GET_LIST_DOC_FOR_EXTEND.REQUEST, 'companyCode', 'requestForCode')
export const exportBGCData = makeAction(EXPORT.REQUEST, 'query', 'onSuccess')

const getBGCompanySuccess = makeAction(GET_LIST.SUCCESS, 'data')
const getBGCompanyDetailSuccess = makeAction(GET_DETAIL.SUCCESS, 'data')
const validateReturnSuccess = makeAction(VALIDATE_RETURN.SUCCESS, 'data')
const getListDocForExtendSuccess = makeAction(GET_LIST_DOC_FOR_EXTEND.SUCCESS, 'data')
const getDetailDocForExtendSuccess = makeAction(GET_DETAIL_DOC_FOR_EXTEND.SUCCESS, 'data')
const exportBGCDataSuccess = makeAction(EXPORT.SUCCESS, 'data')

const apiPath = path => path ? urlWithPrefix(`bgcompany/${path}`) : urlWithPrefix('bgcompany')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* getBGCompanyRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading('Loading Bank Guarantee Company Data'))
    const response = yield httpGet(apiPath(), { ...query })
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGCompanySuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Bank Guarantee Company Error!'))
    }
    yield put(getBGCompanySuccess([]))
    yield put(appLoaded())
  }
}

function* getBGCompanyDetailRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading Bank Guarantee Company Data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGCompanyDetailSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Bank Guarantee Company Error!'))
    }
    yield put(getBGCompanyDetailSuccess({}))
  }
}

function* updateBGCompanyRequest(action) {
  const { data, isSubmit, history, confirm, onRequestConfirm } = action.payload

  try {
    yield put(appLoading('Update bank guarantee company.'))
    const response = yield httpPut(apiPath(data.id), data)
    if (responseIsSuccess(response)) {
      const id = response.data
      var attachmentsData = {}
      if (data.bgc03) attachmentsData.bgc03 = data.bgc03
      if (data.bgc04) attachmentsData.bgc04 = data.bgc04

      if (Object.keys(attachmentsData).length) {
        yield put(appLoading('Upload attachment.'))
        yield httpPost(apiPath(`${id}/attachments`), attachmentsData, multipartHeader)
      }
      if (isSubmit) {
        yield put(appLoading('Submit bank guarantee company.'))
        yield httpPut(apiPath(`${id}/submit`),{confirm:confirm||false})
        yield put(appLoaded())
        yield put(toastSuccess('Update bank guarantee success.'))
        history.push(bgCompanyReportPath)
      } else {
        yield put(appLoaded())
        yield put(toastSuccess('Update bank guarantee success.'))
        history.push(bgCompanyReportPath)
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if(e && e.data && e.data.confirm){
      if(onRequestConfirm) onRequestConfirm(e.data.message)
      else yield put(toastError(e.data.message))
    }else if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update bank guarantee company error!'))
    }
  }
}

function* actionUpdateBGCompanyRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Update bank guarantee company.'))
    let req = {
      docId: data.id,
      comment: data.comment
    }
    if (data.bgc03) req.bgc03 = data.bgc03
    if (data.bgc04) req.bgc04 = data.bgc04
    const response = yield httpPost(apiPath(`${data.id}/action/update`), req, multipartHeader)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      yield put(toastSuccess('Update bank guarantee company success.'))
      history.replace(bgCompanyReportPath)
      window.scrollTo(0,0)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update bank guarantee company error!'))
    }
  }
}

function* actionReturnBGCompanyRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Return bank guarantee company.'))
    const response = yield httpPost(apiPath(`${data.id}/action/return`), data)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      yield put(toastSuccess('Return bank guarantee company success.'))
      history.replace(bgCompanyReportPath)
      window.scrollTo(0,0)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Return bank guarantee company error!'))
    }
  }
}

function* validateReturnRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(apiPath(`${id}/return/validate`))
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(validateReturnSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(validateReturnSuccess({}))
  }
}

function* getDetailDocForExtendRequest(action) {
  const { id } = action.payload
  try {
    yield put(appLoading('Loading Extend Bank Guarantee Company Data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getDetailDocForExtendSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Extend Bank Guarantee Company Error!'))
    }
    yield put(getDetailDocForExtendSuccess({}))
  }
}

function* getListDocForExtendRequest(action) {
  const { companyCode, requestForCode } = action.payload
  try {
    const response = yield httpGet(apiPath('option/docForExtend'), {companyCode:companyCode, requestForCode:requestForCode})
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getListDocForExtendSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getListDocForExtendSuccess([]))
  }
}

function* exportBGCDataRequest(action) {
  const { query, onSuccess } = action.payload

  try {
    yield put(appLoading('Export Bank Guarantee Company Data'))
    const response = yield httpGet(apiPath('export'), { ...query })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        //convert data 
        let res = response.data.map(x=>{
          x.isNoExpireDate = x.isNoExpireDate?'Yes':'No'
          return x
        })
        yield put(exportBGCDataSuccess(res))
        if (onSuccess) onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Export Bank Guarantee Company Error!'))
    }
    yield put(exportBGCDataSuccess([]))
    yield put(appLoaded())
  }
}

export function* watchBGCompanySaga() {
  yield takeLatest(GET_LIST.REQUEST, getBGCompanyRequest)
  yield takeLatest(GET_DETAIL.REQUEST, getBGCompanyDetailRequest)
  yield takeLatest(UPDATE.REQUEST, updateBGCompanyRequest)
  yield takeLatest(ACTION_UPDATE.REQUEST, actionUpdateBGCompanyRequest)
  yield takeLatest(ACTION_RETURN.REQUEST, actionReturnBGCompanyRequest)
  yield takeLatest(VALIDATE_RETURN.REQUEST, validateReturnRequest)
  yield takeLatest(GET_DETAIL_DOC_FOR_EXTEND.REQUEST, getDetailDocForExtendRequest)
  yield takeLatest(GET_LIST_DOC_FOR_EXTEND.REQUEST, getListDocForExtendRequest)
  yield takeLatest(EXPORT.REQUEST, exportBGCDataRequest)
}

const initDetail = {
  contacts:[],
  attachments:[],
  comments:[]
}

const initial = {
  lists: { data: [], loading: false },
  detail: { data: initDetail },
  validateReturn : {},
  detailDocForExtend: { data: {}, loading: false },
  optionDocForExtend: { data: [], loading: false },
  bgcExport: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [GET_LIST.REQUEST]: () => ({
    ...state,
    lists: { data: [], loading: true }
  }),
  [GET_LIST.SUCCESS]: (data) => ({
    ...state,
    lists: { data: data.data, loading: false }
  }),
  [GET_LIST.FAILURE]: (data) => ({
    ...state,
    lists: { data: [], loading: false }
  }),
  [GET_DETAIL.REQUEST]: () => ({
    ...state,
    detail: { data: initDetail, loading: true }
  }),
  [GET_DETAIL.SUCCESS]: (data) => ({
    ...state,
    detail: { data: data.data, loading: false }
  }),
  [VALIDATE_RETURN.REQUEST]: () => ({
    ...state,
    validateReturn: {}
  }),
  [VALIDATE_RETURN.SUCCESS]: (data) => ({
    ...state,
    validateReturn: data.data
  }),
  [GET_DETAIL_DOC_FOR_EXTEND.REQUEST]: () => ({
    ...state,
    detailDocForExtend: { data: [], loading: true }
  }),
  [GET_DETAIL_DOC_FOR_EXTEND.SUCCESS]: (data) => ({
    ...state,
    detailDocForExtend: { data: data.data, loading: false }
  }),
  [GET_LIST_DOC_FOR_EXTEND.REQUEST]: () => ({
    ...state,
    optionDocForExtend: { data: [], loading: true }
  }),
  [GET_LIST_DOC_FOR_EXTEND.SUCCESS]: (data) => ({
    ...state,
    optionDocForExtend: { data: data.data, loading: false }
  }),
  [EXPORT.REQUEST]: () => ({
    ...state,
    bgcExport: { data: [], loading: true }
  }),
  [EXPORT.SUCCESS]: (data) => ({
    ...state,
    bgcExport: { data: data.data, loading: false }
  }),
}))